import forgetPwd from '../views/login/retrievePwd.vue'
import loginReg from '../views/login/loginNew.vue'
import setPwd from '../views/login/setPwd.vue'
import hello from '../views/login/hello.vue'

// const install = function(Vue,options) {
//   Vue.component(forgetPwd.name, forgetPwd)
//   Vue.component(loginReg.name, loginReg)
//   Vue.component(setPwd.name, setPwd)
// }

// const zhaobiLogin={
//   install(Vue,options){
//     Vue.component(forgetPwd.name, forgetPwd)
//     Vue.component(loginReg.name, loginReg)
//     Vue.component(setPwd.name, setPwd)
//   }
// }

const zhaobiLogin={
  install(Vue,options){
    Vue.component(forgetPwd.name, forgetPwd)
    Vue.component(loginReg.name, loginReg)
    Vue.component(setPwd.name, setPwd)
    Vue.component('Hello',hello)
  }
}
export default zhaobiLogin


// WEBPACK FOOTER //
// ./src/lib/index.js